import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import { Trigger } from 'store/triggers/triggers.types';

const initialState = {
  options: [] as { label: string; value: string }[]
};

const triggersSlice = createSlice({
  initialState,
  name: 'triggers',
  reducers: {
    setTriggerOptions(state, action: PayloadAction<Trigger[]>) {
      state.options = action.payload.map((trigger) => ({
        label: trigger.name,
        value: trigger._id
      }));
    }
  }
});

export const { setTriggerOptions } = triggersSlice.actions;

export const selectTriggers = (state: RootState) => state.triggers;

export default triggersSlice.reducer;
